import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeletePerson = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/persons/${id}`)
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Persons] })
    },
  })
}
